module.exports = __webpack_public_path__ + "img/servOrder.8ec4814c.svg";